import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";

const OrientationGuard = ({ children }) => {
    const [isLandscape, setIsLandscape] = useState(false);

    useEffect(() => {
        const checkOrientation = () => {
            // Logic to detect landscape mode. 
            // We check if width > height and also if it's a mobile-like screen size 
            // to avoid triggering on laptops (though user asked for mobile behavior).
            const landscape = window.innerWidth > window.innerHeight && window.innerWidth < 1024;
            setIsLandscape(landscape);
        };

        checkOrientation();
        window.addEventListener("resize", checkOrientation);
        window.addEventListener("orientationchange", checkOrientation);

        return () => {
            window.removeEventListener("resize", checkOrientation);
            window.removeEventListener("orientationchange", checkOrientation);
        };
    }, []);

    return (
        <>
            <div className={isLandscape ? "content-blur" : ""}>
                {children}
            </div>

            {isLandscape && (
                <div className="orientation-overlay">
                    <div className="orientation-message">
                        <div className="phone-icon-container">
                            <FontAwesomeIcon icon={faMobileAlt} className="rotate-animation" />
                        </div>
                        <h2>Tryb Pionowy Wymagany</h2>
                        <p>Aplikacja działa w trybie pionowym, proszę obróć telefon</p>
                    </div>
                </div>
            )}

            <style>{`
        .content-blur {
          filter: blur(10px);
          pointer-events: none;
          user-select: none;
          transition: filter 0.3s ease;
        }

        .orientation-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(255, 255, 255, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999999;
          backdrop-filter: blur(5px);
          animation: fadeInOverlay 0.3s ease-out;
        }

        .orientation-message {
          text-align: center;
          padding: 2rem;
          color: #1a1a1a;
          max-width: 400px;
        }

        .phone-icon-container {
          font-size: 4rem;
          margin-bottom: 1.5rem;
          color: #2572DF;
        }

        .rotate-animation {
          animation: rotatePhone 2s infinite ease-in-out;
        }

        @keyframes rotatePhone {
          0% { transform: rotate(90deg); }
          50% { transform: rotate(0deg); }
          100% { transform: rotate(90deg); }
        }

        @keyframes fadeInOverlay {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .orientation-message h2 {
          font-weight: 800;
          margin-bottom: 10px;
          font-size: 1.5rem;
        }

        .orientation-message p {
          font-size: 1.1rem;
          opacity: 0.8;
          line-height: 1.4;
        }
      `}</style>
        </>
    );
};

export default OrientationGuard;
